export enum CourseType {
    IncomeTax,
}

export enum CourseActionType {
    ResumeLearning,
    WatchNow,
}

export enum ProgramType {
    Course,
    Webinar,
    Podcast,
}

export enum WebinarType {
    Live,
    Recorded,
}

export enum ProgramLanguage {
    English = 1,
    Mandarin = 2,
}

export enum ProgramFilter {
    None,
    UpcomingWebinars,
    LatestCourses,
    Featured,
    LiveWebinars,
}

export enum FilterType {
    Language,
    ProgramType,
    WebinarType,
    Topic,
    Year,
}

export enum LearningStatusType {
    OnGoing,
    Completed,
    Registered,
    Attended,
}

export enum CreditType {
    Unstructured = 0,
    Structured = 1,
}

export enum ProgramMenuType {
    Course = 'course',
    Webinar = 'webinar',
    EInvoicing = 'e-invoicing',
    UpdateClasses = 'update-classes',
    IncomeTax = 'income-tax',
    Forms = 'forms',
    SST = 'sst',
    Podcast = 'podcast',
}
